import { app } from '../../app';

app.component('captcha', {
    bindings: {state: '<'},
    templateUrl: require('./captcha.html')
});



// WEBPACK FOOTER //
// ./src/portal/components/captcha/captcha.component.js